export default __webpack_public_path__ + "static/services-image3-506c1493c0e72abde2c5f4c60fd2dab3.jpg";